// import Form from 'olive-react-myoneui/lib/Form';
// import FloatingLabel from 'olive-react-myoneui/lib/FloatingLabel';
// import ToggleButtonGroup from 'olive-react-myoneui/lib/ToggleButtonGroup';
// import ToggleButton from 'olive-react-myoneui/lib/ToggleButton';
import React, { useState, useEffect } from 'react';
import CircleImage from 'olive-react-myoneui/lib/CircleImage';
import Button from 'olive-react-myoneui/lib/Button';
import { copyIcon } from '../../constants/icons';

function LiveClassBlock({ className, courseLogo, courseTitle, joinButton, joinLink, copyButton, liveClassTime }) {
  const [isCopied, setIsCopied] = useState(false);

  const joinClickHandler = (e) => {
    window.open(joinLink, '_blank', 'noopener,noreferrer');
    // window.location.replace(joinLink);
  }

  async function copyTextToClipboard(text) {
    if ('clipboard' in navigator) {
      return await navigator.clipboard.writeText(text);
    } else {
      return document.execCommand('copy', true, text);
    }
  }

  const handleCopyClick = () => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(joinLink)
      .then(() => {
        // If successful, update the isCopied state value
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 1500);
      })
      .catch((err) => {
        console.log(err);
      });
  }

  return (
    <div className={`${className || ''} liveclass-block information-block information-block-sm-pd p-0`}>
      <div className="information-wrap">
        <div className="information-holder gap-2 liveclass-info-holder">
          <div className='liveclass-wrap live123'>
            {courseLogo && (
              <CircleImage className="circle-wrap rect-wrap">
                <img src={courseLogo} className="img-fluid" />
              </CircleImage>
            )}
            <div className="information-detail">
              <h3 className="mb-1">{courseTitle}</h3>
              {liveClassTime && <span>{liveClassTime}</span>}
            </div>
          </div>
          <div className='liveclass-btn-wrap'>
            {joinButton && (
              <Button
                variant="primary"
                className="btn-round px-3"
                size="sm"
                onClick={joinClickHandler}
              >
                {joinButton}
              </Button>
            )}
            {copyButton && (
              <Button
                variant="leading-icon"
                className="leading-icon btn-round"
                size="sm"
                onClick={handleCopyClick}
              >
                {copyIcon}
                {copyButton}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveClassBlock;
